import { useHook, useMutationHook } from '../utils/use-hook'
import { mutationFetcher } from '../utils/default-fetcher'
import type { HookFetcherFn, MutationHook } from '../utils/types'
import type { ApplyDiscountHook } from '../types/cart'
import type { Provider } from '..'

export type UseApplyDiscount<
  H extends MutationHook<ApplyDiscountHook<any>> = MutationHook<ApplyDiscountHook>
> = ReturnType<H['useHook']>

export const fetcher: HookFetcherFn<ApplyDiscountHook> = mutationFetcher

const fn = (provider: Provider) => provider.cart?.useApplyDiscount!

const useApplyDiscount: UseApplyDiscount = (...args) => {
  const hook = useHook(fn)
  return useMutationHook({ fetcher, ...hook })(...args)
}

export default useApplyDiscount
